export type AstralThemeColor = 'primary' | 'secondary' | 'success' | 'warning' | 'transparent';
